import { Route, Routes } from 'react-router';
import { onSpendingUsable } from '../../data/commands/spending';
import { onModuleUsable } from '../../data/moduleHooks';
import { registerTile } from '../../tiles/registry';
import { registerWebModule } from '../registry';
import { SpendingIcon } from './SpendingIcon';
import { copy } from './copy';
import { BreakdownScreen } from './screens/BreakdownScreen';
import { CategoriesScreen } from './screens/CategoriesScreen';
import { EditEntryRoute } from './screens/EditEntryRoute';
import { EntryDetailScreen } from './screens/EntryDetailScreen';
import { EntryListScreen } from './screens/EntryListScreen';
import { QuickAddRoute } from './screens/QuickAddRoute';
import { SpendingDashboard } from './screens/SpendingDashboard';
import { TidyUpScreen } from './screens/TidyUpScreen';
import { TodayTile } from './tiles/TodayTile';
import {
  TopCategoriesSettings,
  TopCategoriesTile,
  type TopCategoriesConfig,
} from './tiles/TopCategoriesTile';
import { WeekTile } from './tiles/WeekTile';

/** Mounted by v0.1c's ModuleRoute at /m/spending/* (route `m/:moduleId/*`), so these paths are relative. */
function SpendingScreen() {
  return (
    <Routes>
      <Route index element={<SpendingDashboard />} />
      <Route path="add" element={<QuickAddRoute />} />
      <Route path="entries" element={<EntryListScreen />} />
      <Route path="entries/:id" element={<EntryDetailScreen />} />
      <Route path="entries/:id/edit" element={<EditEntryRoute />} />
      <Route path="tidy" element={<TidyUpScreen />} />
      <Route path="categories" element={<CategoriesScreen />} />
      <Route path="breakdown" element={<BreakdownScreen />} />
    </Routes>
  );
}

registerWebModule({
  id: 'spending',
  navLabel: copy.moduleName,
  Icon: SpendingIcon,
  Screen: SpendingScreen,
});

registerTile({
  type: 'spending.today',
  moduleId: 'spending',
  title: copy.spentToday,
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  defaultOnToday: true,
  Component: TodayTile,
});

registerTile({
  type: 'spending.week',
  moduleId: 'spending',
  title: copy.spentThisWeek,
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  Component: WeekTile,
});

registerTile<TopCategoriesConfig>({
  type: 'spending.top-categories',
  moduleId: 'spending',
  title: copy.topCategories,
  sizes: ['wide', 'tall'],
  defaultSize: 'tall',
  Component: TopCategoriesTile,
  Settings: TopCategoriesSettings,
});

// Runs whenever Spending becomes usable: toggle, admin forced_on, or app start (Task 16).
// The hook gets the CommandEnv from ModuleHooksRunner.
onModuleUsable('spending', onSpendingUsable);
